import React from "react";
import { ToastContainer } from "react-toastify";
import ViewCategory from "../../components/ProductManager/Category/ViewCategory";

export const ViewCategoryPage = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ViewCategory />
        </div>
      </div>
    </div>
  );
};
